"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var yup = require("yup");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var operators_1 = require("rxjs/operators");
var Types_1 = require("../../../Types");
var Page_1 = require("../../Page");
var Notification_1 = require("../../Notification");
var react_1 = require("@monaco-editor/react");
var Pagination_1 = require("../../../helpers/Pagination");
var InteractionSearchResultsTableWithComparison_1 = require("./InteractionSearchResultsTableWithComparison");
var InteractionSearchPage = /** @class */ (function (_super) {
    __extends(InteractionSearchPage, _super);
    function InteractionSearchPage(props) {
        var _this = _super.call(this, props) || this;
        _this.renderPageContent = function () {
            var formErrors = _this.state.formErrors;
            return ((0, jsx_runtime_1.jsxs)("div", { className: "panel-border", children: [(0, jsx_runtime_1.jsx)(Notification_1.default, { show: _this.state.showInteraction, hide: _this.toggleInteractionModal, title: "Interaction", body: ((0, jsx_runtime_1.jsx)(react_1.default, { height: "100%", width: "100%", language: "json", value: _this.state.interactionAsString, onMount: function (editor, monaco) { return editor.focus(); } })), style: {
                            maxHeight: "100%",
                            height: "100%",
                            margin: "0",
                            maxWidth: "100%",
                            width: "100%"
                        } }), (0, jsx_runtime_1.jsxs)("form", { onSubmit: _this.handleSubmit, autoComplete: "off", children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-group", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "interactionId", children: "Interaction ID" }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group p-0", children: [(0, jsx_runtime_1.jsx)("input", { type: "text", id: "interactionId", name: "interactionId", className: "form-control ".concat(formErrors.interactionId ? "is-invalid" : ""), value: _this.state.form.interactionId, onChange: _this.handleFormChange }), formErrors.interactionId && ((0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: formErrors.interactionId }))] }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "email", className: "mt-2", children: "Email" }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group p-0", children: [(0, jsx_runtime_1.jsx)("input", { type: "text", id: "email", name: "email", className: "form-control ".concat(formErrors.email ? "is-invalid" : ""), value: _this.state.form.email, onChange: _this.handleFormChange }), formErrors.email && ((0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: formErrors.email }))] }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "mqsId", className: "mt-2", children: "MQS quote ID" }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group p-0", children: [(0, jsx_runtime_1.jsx)("input", { type: "text", id: "mqsId", name: "mqsId", className: "form-control ".concat(formErrors.mqsId ? "is-invalid" : ""), value: _this.state.form.mqsId, onChange: _this.handleFormChange }), formErrors.mqsId && ((0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: formErrors.mqsId }))] }), (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn btn-primary mt-3", children: "Search" })] }), (0, jsx_runtime_1.jsx)(Pagination_1.default, { limit: _this.state.limit, offset: _this.state.offset, total: _this.state.searchResult.count, onClickPrevious: _this.handleClickPrevious, onClickNext: _this.handleClickNext, onClickPageNumber: _this.handleClickPageNumber }), _this.state.isTableLoaded && !_this.state.noResultError &&
                                (0, jsx_runtime_1.jsx)(InteractionSearchResultsTableWithComparison_1.default, { resetCompareSelection: _this.state.resetCompareSelection, interactions: _this.state.searchResult.results, onResetCompareSelectionHandle: _this.onResetCompareSelectionHandle, onInteractionSearchClick: _this.onInteractionSearchClick })] })] }));
        };
        _this.handleFormChange = function (event) {
            var form = __assign({}, _this.state.form);
            var target = event.target;
            form[target.name] = target.value.trim();
            _this.setState({ form: form }, _this.validateForm);
        };
        _this.validateForm = function () {
            return _this.formSchema
                .validate(_this.state.form, { abortEarly: false })
                .then(function () { return _this.setState({ formErrors: {} }); })
                .catch(function (caughtErrors) {
                var formErrors = {};
                caughtErrors.inner.reverse().forEach(function (innerError) {
                    formErrors[innerError.path] = innerError.message;
                });
                _this.setState({ formErrors: formErrors });
            });
        };
        _this.isFormValid = function () {
            return Object.keys(_this.state.formErrors).length === 0;
        };
        _this.handleSubmit = function (event) {
            event.preventDefault();
            var form = __assign({}, _this.state.form);
            form.hasBeenSubmitted = true;
            _this.setState({ form: form }, function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.validateForm()];
                        case 1:
                            _a.sent();
                            if (this.isFormValid()) {
                                this.search();
                            }
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        _this.search = function () {
            _this.setState({
                isLoading: true,
                interactionAsString: "",
                searchResult: {
                    count: 0,
                    results: []
                }
            }, function () {
                // When interaction ID is present, search by interaction ID directly
                if (_this.state.form.interactionId !== "") {
                    _this.supportPortalService.getInteraction(_this.state.form.interactionId)
                        .pipe((0, operators_1.finalize)(function () { return _this.setState({ isLoading: false }); }))
                        .subscribe(function (interaction) {
                        if (interaction) {
                            _this.supportPortalService.logAgentActivity(interaction.userReference, { "action": "Search interaction", "customer": interaction.agreementNumber }).subscribe();
                            _this.setState({
                                interactionAsString: JSON.stringify(interaction, null, "    ")
                            });
                            _this.toggleInteractionModal();
                        }
                        else {
                            _this.showInteractionNotFound();
                        }
                    });
                }
                else {
                    // When interaction ID is not present, search broadly with other forms of field data and show results in a table
                    _this.supportPortalService.getInteractions({
                        interactionId: _this.state.form.interactionId,
                        email: _this.state.form.email,
                        mqsQuoteId: _this.state.form.mqsId,
                        limit: _this.state.limit,
                        page: Math.ceil(_this.state.offset / _this.state.limit)
                    })
                        .pipe((0, operators_1.finalize)(function () { return _this.setState({
                        isLoading: false
                    }); }))
                        .subscribe(function (searchResult) {
                        if (searchResult.count === 0) {
                            _this.showInteractionNotFound();
                        }
                        else {
                            _this.setState(function () { return ({
                                isLoading: false,
                                isTableLoaded: true,
                                searchResult: searchResult,
                                noResultError: searchResult.count === 0,
                                resetCompareSelection: true
                            }); });
                        }
                    }, function (error) {
                        _this.setState({
                            isLoading: false,
                            isTableLoaded: false
                        }, function () { return console.error("Something went wrong", error); });
                    });
                }
            });
        };
        _this.onResetCompareSelectionHandle = function () {
            _this.setState({
                resetCompareSelection: false
            });
        };
        _this.onInteractionSearchClick = function (interactionSearchResult) {
            _this.supportPortalService.getInteraction(interactionSearchResult._id)
                .pipe((0, operators_1.finalize)(function () { return _this.setState({ isLoading: false }); }))
                .subscribe(function (interaction) {
                _this.setState({
                    interactionAsString: JSON.stringify(interaction, null, "    ")
                });
                _this.toggleInteractionModal();
            });
        };
        _this.handleClickPrevious = function () {
            _this.setState(function (state) {
                var offset = state.offset;
                var newOffset = state.offset - state.limit;
                if (newOffset >= 0) {
                    offset = newOffset;
                }
                return { offset: offset };
            }, _this.search);
        };
        _this.handleClickNext = function () {
            _this.setState(function (state) {
                var offset = state.offset;
                var newOffset = state.offset + state.limit;
                if (newOffset < state.searchResult.count) {
                    offset = newOffset;
                }
                return { offset: offset };
            }, _this.search);
        };
        _this.handleClickPageNumber = function (pageNumber) {
            _this.setState(function (state) {
                var offset = state.offset;
                var newOffset = state.limit * (pageNumber - 1);
                if (newOffset >= 0 && newOffset < state.searchResult.count) {
                    offset = newOffset;
                }
                return { offset: offset };
            }, _this.search);
        };
        _this.handleAlertClose = function () {
            _this.setState({
                alert: {
                    show: false,
                    title: "",
                    message: ""
                }
            });
        };
        _this.toggleInteractionModal = function () {
            _this.setState(function (prevState) { return ({
                showInteraction: !prevState.showInteraction
            }); });
        };
        _this.showInteractionNotFound = function () {
            _this.setState({
                interactionAsString: "",
                alert: {
                    show: true,
                    title: "Not found",
                    message: "Interaction not found"
                }
            });
        };
        var requiredMessage = "To search you must provide data in at least one of the form fields";
        _this.formSchema = yup.object().shape({
            hasBeenSubmitted: yup.boolean(),
            interactionId: yup
                .string()
                .matches(/^$|^[a-fA-F0-9]{24}$/, { message: "Invalid ID format" })
                .ensure().when(["email", "mqsId"], {
                is: function (email, mqsId) { return !email && !mqsId; },
                then: yup.string().required(requiredMessage)
            }),
            email: yup
                .string()
                .email("Invalid email format")
                .ensure().when(["interactionId", "mqsId"], {
                is: function (interactionId, mqsId) { return !interactionId && !mqsId; },
                then: yup.string().required(requiredMessage)
            }),
            mqsId: yup
                .string()
                .matches(/^$|^(?:MQS-)?[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$/i, {
                message: "Invalid MQS ID format"
            })
                .ensure()
                .when(["interactionId", "email"], {
                is: function (interactionId, email) { return !interactionId && !email; },
                then: yup.string().required(requiredMessage)
            })
        }, [
            ["interactionId", "email"],
            ["interactionId", "mqsId"],
            ["email", "mqsId"]
        ]);
        _this.state = {
            isLoading: false,
            form: {
                hasBeenSubmitted: false,
                interactionId: "",
                email: "",
                mqsId: ""
            },
            formErrors: {},
            alert: {
                show: false,
                title: "",
                message: ""
            },
            interactionAsString: "",
            searchResult: {
                count: 0,
                results: []
            },
            noResultError: false,
            limit: 50,
            offset: 0,
            showInteraction: false,
            isTableLoaded: false,
            resetCompareSelection: false
        };
        return _this;
    }
    InteractionSearchPage.prototype.componentDidMount = function () {
        var _this = this;
        this.supportPortalService.logAgentActivity("NO_REFERENCE", { "action": "No Action", "customer": "AGENT_ONLY" }).subscribe(function (agentActivity) {
            _this.setState({ agentActivityId: agentActivity.id });
        });
    };
    InteractionSearchPage.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(Page_1.default, { title: "Interaction search", isLoading: this.state.isLoading, children: [(0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.alert.show, hide: this.handleAlertClose, title: this.state.alert.title, message: this.state.alert.message }), (0, jsx_runtime_1.jsx)("h1", { className: "text-white", children: "Interaction search" }), this.renderPageContent()] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], InteractionSearchPage.prototype, "supportPortalService", void 0);
    InteractionSearchPage = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], InteractionSearchPage);
    return InteractionSearchPage;
}(React.Component));
exports.default = InteractionSearchPage;
//# sourceMappingURL=InteractionSearchPage.js.map